<div class="p-4">
    <nz-skeleton
      [ngClass]="loading ? 'p-3' : 'p-0'"
      [nzLoading]="loading"
      [nzActive]="true"
    >
    <div class="d-flex flex-column gap-1">
        <span class="text-black title">API Shipping Usage</span>
        <hr>
        <div class="mt-3 d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center gap-1">
                <span>Daily Usage</span>
                <div
                    class="d-flex align-self-center align-items-center"
                    placement="top right"
                    ngbPopover="All API requests count toward your quota, including failed requests and retries from your application"
                    triggers="mouseenter:mouseleave"
                  >
                    <i class="icon-info-circle align-self-center"></i>
                </div>
            </div>
            <span class="text-black">{{ ( apiUsageData?.daily_usage | number ) || 0 }}/{{ ( apiUsageData?.daily_limit | number) || 0 }}</span>
        </div>
        <div class="progress h-3" role="progressbar" aria-label="Success example" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
            <div
                class="progress-bar bg-primary"
                [ngStyle]="{ width: usagePercent() }"
            ></div>
        </div>
        <div class="mt-4 text-muted d-flex flex-column gap-3">
            <div class="d-flex justify-content-between">
                <span>Request Today</span>
                <span class="font-bold text-black">{{ apiUsageData?.daily_usage || 0 }}</span>
            </div>
            <div class="d-flex justify-content-between">
                <span>Avg Response Time</span>
                <span class="font-bold text-black">{{ (apiUsageData?.avg_response_time | number:'1.2-2' ) || 0 }} ms</span>
            </div>
            <div class="d-flex justify-content-between">
                <span>Success Rate</span>
                <span class="font-bold text-black">{{ (apiUsageData?.success_rate | number:'1.2-2') || 0 }}%</span>
            </div>
        </div>
    </div>
    </nz-skeleton>
</div>
